import type { ActivationFlowAction, ActivationFlowModel } from './ActivationFlow.types'

export const reduceActivationTokenAction = (
  state: ActivationFlowModel,
  action: ActivationFlowAction,
): ActivationFlowModel | null => {
  switch (action.type) {
    case 'INIT_FROM_QUERY': {
      return {
        ...state,
        token: action.token,
        status: action.token ? 'loading' : 'invalid',
        recovery: {
          ...state.recovery,
          email: action.recoveryEmail || state.recovery.email,
          success: false,
          submitState: 'idle',
          feedback: '',
          feedbackTone: 'error',
        },
      }
    }
    case 'TOKEN_VALID': {
      return {
        ...state,
        status: 'setup',
      }
    }
    case 'TOKEN_EXPIRED': {
      return {
        ...state,
        status: 'expired',
        setup: {
          ...state.setup,
          submitState: 'idle',
        },
      }
    }
    case 'TOKEN_INVALID':
    case 'TOKEN_VALIDATION_FAILED': {
      return {
        ...state,
        status: 'invalid',
        setup: {
          ...state.setup,
          submitState: 'idle',
        },
      }
    }
    default:
      return null
  }
}
